import * as React from 'react';
import type { SportItem } from '../types/sport-icon.type';
import type { ClassNameProp } from '@utils';
import { cn } from '@utils';
import { getSportIconComponent } from '../sport-icon-registry';

interface SportIconProps extends ClassNameProp {
	sport: SportItem;
}

/**
 * Renders a sport icon from the static registry, with legacy API key aliases.
 */
export const SportIcon: React.FC<SportIconProps> = ({ sport, className }: SportIconProps): JSX.Element | null => {
	const Component = getSportIconComponent(sport.icon);

	if (!Component) {
		return null;
	}

	return <Component className={cn(className)} data-testid="sport-icon" />;
};
